<template>
  <div id="add_chat_user" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Mulai Chat Langsung</h5>
          <button
            type="button"
            class="waajo-direct-add-toggle"
            @click="openAddContactForm()"
          >
            <i class="fa fa-user-plus"></i>
            Tambah Kontak Baru
          </button>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="showAddContactForm" class="waajo-direct-add-panel">
            <div class="waajo-direct-add-head">
              <div>
                <strong>Tambah Kontak Baru</strong>
                <small>Simpan kontak lalu langsung mulai chat.</small>
              </div>
              <button type="button" class="close" @click="cancelAddContactForm">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="submitNewContact">
              <div class="form-group">
                <label>Nama Kontak <span class="text-danger">*</span></label>
                <input
                  ref="newContactName"
                  v-model="newContact.first_name"
                  type="text"
                  class="form-control"
                  :disabled="addContactLoading"
                  placeholder="Contoh: Ibu Ani"
                />
              </div>
              <div class="form-group">
                <label>Nomor WhatsApp <span class="text-danger">*</span></label>
                <input
                  v-model="newContact.phone_number"
                  type="tel"
                  class="form-control"
                  :disabled="addContactLoading"
                  placeholder="Contoh: 081234567890"
                />
              </div>
              <div class="form-group">
                <label>Email <span class="text-muted">(opsional)</span></label>
                <input
                  v-model="newContact.email"
                  type="email"
                  class="form-control"
                  :disabled="addContactLoading"
                  placeholder="nama@email.com"
                />
              </div>
              <p v-if="addContactError" class="waajo-direct-add-error">
                <i class="fa fa-exclamation-circle"></i>
                {{ addContactError }}
              </p>
              <div class="waajo-direct-add-actions">
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  :disabled="addContactLoading"
                  @click="cancelAddContactForm"
                >
                  Batal
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="addContactLoading"
                >
                  <i v-if="addContactLoading" class="fa fa-spinner fa-spin"></i>
                  {{ addContactLoading ? "Menyimpan..." : "Simpan & Mulai Chat" }}
                </button>
              </div>
            </form>
          </div>

          <div class="input-group m-b-30">
            <input
              v-model="contactListParam.name"
              placeholder="Cari kontak untuk memulai chat..."
              class="form-control search-input"
              type="text"
              @change="filterContactListByName"
              @keyup.enter="filterContactListByName"
            />
            <span class="input-group-append">
              <button @click="filterContactListByName" class="btn btn-primary">Cari</button>
            </span>
          </div>
          <div>
            <!-- <h5>Recent Conversations</h5> -->
            <ul class="chat-user-list" style="max-height: 300px;overflow: auto;">
              <!-- <ul class="chat-user-list"> -->
              <li v-if="loadingMessage">
                <a href="#">
                  <div class="media">
                    <span class="avatar align-self-center">
                      <img src="@/assets/profiles/avatar-16.jpg" alt />
                    </span>
                    <div class="media-body align-self-center text-nowrap">
                      <div class="user-name">
                        <Skeleton :count="1" />
                      </div>
                      <span class="designation">
                        <Skeleton :count="1" />
                      </span>
                      <span class="designation">
                        <Skeleton :count="1" />
                      </span>
                    </div>
                    <!-- <div class="text-nowrap align-self-center">
                      <div class="online-date">1 day ago</div>
                    </div>-->
                  </div>
                </a>
              </li>
              <li v-for="row in contactListArr" :key="`${row.id}`">
                <a href="javascript:void(0)" data-dismiss="modal" @click="addDirectChat(row)">
                  <div class="media">
                    <span class="avatar align-self-center">
                      <img src="@/assets/profiles/avatar-16.jpg" alt />
                    </span>
                    <div class="media-body align-self-center text-nowrap">
                      <div class="user-name">
                        <span v-if="row.first_name==''" class="contact-name text-ellipsis">Tanpa Nama</span>
                        <span v-else class="contact-name text-ellipsis">
                          {{row.first_name}}
                          {{row.last_name}}
                        </span>
                      </div>
                      <span class="designation" v-if="row.phone_number!='0'">
                        <i class="fa fa-phone-square"></i>
                        {{row.phone_number}}
                      </span>
                      <span class="designation" v-if="row.email!=''">
                        <i class="fa fa-envelope-o"></i>
                        {{row.email}}
                      </span>
                    </div>
                    <!-- <div class="text-nowrap align-self-center">
                      <div class="online-date">1 day ago</div>
                    </div>-->
                  </div>
                </a>
              </li>
            </ul>
            <infinite-loading-contact
              ref="infiniteLoading"
              :identifier="infiniteId"
              spinner="spiral"
              @infinite="infiniteHandlerContact"
            >
              <div slot="spinner">
                <span v-if="loadingMessage">Memuat...</span>
              </div>
              <!-- <div slot="no-more">No more messages</div> -->
              <div slot="no-more">
                <span
                  v-if="(this.contactListParam.totalRecords>0 && this.contactListParam.rendered>=this.contactListParam.totalRecords)"
                >Tidak ada kontak lagi</span>
                <span v-if="(this.contactListParam.totalRecords==0)">Tidak ada kontak</span>
                <span
                  v-if="(this.contactListParam.totalRecords>0 && this.contactListParam.rendered==0)"
                >Tidak ada kontak</span>
              </div>
              <div slot="no-results">
                <span v-if="(this.contactListParam.totalRecords==0)">Kontak tidak ditemukan</span>
                <span v-else>Tidak ada kontak lagi</span>
              </div>
            </infinite-loading-contact>
          </div>
          <!-- <div class="submit-section">
            <button class="btn btn-primary submit-btn">Submit</button>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { Skeleton } from "vue-loading-skeleton";
import InfiniteLoading from "vue-infinite-loading";
import { mapGetters } from "vuex";

export default {
  components: {
    InfiniteLoadingContact: InfiniteLoading,
    Skeleton
  },
  data() {
    return {
      currentState: null,
      infiniteId: +new Date(),
      showUpdate: "",
      showAddContactForm: false,
      addContactLoading: false,
      addContactError: "",
      newContact: {
        first_name: "",
        phone_number: "",
        email: ""
      },
      loadingGroup: false,
      currentState: null,
      loadingMessage: true,
      initScrollTop: 0,
      newData: [],
      currentGroupId: "",
      groupListParam: {
        name: "",
        page: 0,
        perPage: 1000
      },
      contactListParam: {
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      }
    };
  },
  watch: {
    isShowDirectChats: {
      handler: function(val, oldVal) {
        console.log("isShowDirectChats:oldVal", oldVal);
        console.log("newVal", val);
        if (val == true) {
          // Setiap kali modal dibuka, mulai lagi dari halaman pertama.
          this.contactListParam.page = 0;
          this.contactListParam.rendered = 0;
          this.contactListParam.totalRecords = 0;
          this.contactListParam.name = "";
          this.contactListParam.perPage = 10;
          this.resetContactListArr();
          this.infiniteHandlerContact();

          //   this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
          //   });
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["agentSession"]),
    isShowDirectChats() {
      return this.$store.state.omniroom.isShowDirectChats;
    },
    contactListArr() {
      return this.$store.state.contact.contactListArr;
    },
    roomListArr() {
      return this.$store.state.omniroom.roomListArr;
    },
    groupListArr() {
      return this.$store.state.contact.groupListArr;
    }
  },
  methods: {
    normalizePhone(value) {
      return String(value || "").replace(/\D/g, "");
    },
    roomMatchesPhone(room, phone) {
      if (!room || !phone) {
        return false;
      }
      return [room.room_number, room.room_jid, room.room_lid].some(value => {
        return this.normalizePhone(value) === phone;
      });
    },
    addDirectChat(row) {
      this.openChatForContact(row);
    },
    async openChatForContact(row) {
      const phone = this.normalizePhone(row.phone_number);
      if (!phone) {
        this.addContactError = "Nomor WhatsApp kontak tidak tersedia.";
        return;
      }

      let existingRoom = (this.roomListArr || []).find(room => {
        return this.roomMatchesPhone(room, phone);
      });

      // Daftar room di sidebar bisa belum memuat semua halaman. Cek server
      // dengan endpoint daftar room yang sudah ada sebelum membuat room baru.
      if (!existingRoom) {
        try {
          const result = await this.$store.dispatch("omniroom/getRoomList", {
            keywords: phone,
            options: "",
            tags_filter: false,
            untag: false,
            tags_id: "",
            page: 0,
            perPage: 10
          });
          existingRoom = ((result && result.data) || []).find(room => {
            return this.roomMatchesPhone(room, phone);
          });
        } catch (error) {
          // Bila pencarian gagal, gunakan fallback daftar room yang sudah dimuat.
        }
      }

      if (existingRoom) {
        this.$root.$emit("addDirectChat", existingRoom);
        this.closeDirectModal();
        return;
      }

      const displayName =
        String(row.first_name || "").trim() ||
        [row.first_name, row.last_name].filter(Boolean).join(" ").trim() ||
        phone;
      const unixTimestamp = Math.round(+new Date() / 1000);
      const newRoom = {
        id: "new-room",
        license_id: this.agentSession.license_id,
        provider: "whatsapp",
        room_title: displayName,
        room_number: phone + "@s.whatsapp.net",
        room_photo: "",
        room_last_chat_name: displayName,
        room_last_chat_message: "",
        is_deleted: 0,
        create_datetime: unixTimestamp,
        update_datetime: unixTimestamp,
        num_unread: 0,
        is_group: 0
      };

      this.$root.$emit("addDirectChat", newRoom);
      this.closeDirectModal();
    },
    closeDirectModal() {
      $("#add_chat_user").modal("hide");
    },
    openDirectModal(preserveForm = false) {
      if (!preserveForm) {
        this.showAddContactForm = false;
      }
      this.$store.dispatch("omniroom/setIsShowDirectChats", false);
      this.$nextTick(() => {
        this.$store.dispatch("omniroom/setIsShowDirectChats", true);
        this.$nextTick(() => {
          $("#add_chat_user").modal("show");
        });
      });
    },
    openAddContactForm(prefill) {
      this.showAddContactForm = true;
      this.addContactError = "";
      this.newContact = {
        first_name: prefill && prefill.room_title ? prefill.room_title : "",
        phone_number:
          prefill && prefill.room_number
            ? this.normalizePhone(prefill.room_number)
            : "",
        email: ""
      };
      this.openDirectModal(true);
      this.$nextTick(() => {
        if (this.$refs.newContactName) {
          this.$refs.newContactName.focus();
        }
      });
    },
    cancelAddContactForm() {
      if (this.addContactLoading) {
        return;
      }
      this.showAddContactForm = false;
      this.addContactError = "";
    },
    async submitNewContact() {
      if (this.addContactLoading) {
        return;
      }

      const name = String(this.newContact.first_name || "").trim();
      const phone = this.normalizePhone(this.newContact.phone_number);
      const email = String(this.newContact.email || "").trim();

      if (!name) {
        this.addContactError = "Nama kontak wajib diisi.";
        return;
      }
      if (!phone || phone.length < 8 || phone.length > 15) {
        this.addContactError = "Nomor WhatsApp harus terdiri dari 8-15 digit.";
        return;
      }
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.addContactError = "Format email tidak valid.";
        return;
      }

      const existingContact = (this.contactListArr || []).find(row => {
        return this.normalizePhone(row.phone_number) === phone;
      });
      if (existingContact) {
        this.openChatForContact(existingContact);
        return;
      }

      this.addContactLoading = true;
      this.addContactError = "";

      try {
        await this.$store.dispatch("contact/createContact", {
          first_name: name,
          last_name: "",
          email: email,
          phone_number: phone,
          list_id: [],
          birth_date_data: "",
          birth_date_is_filled: 0
        });

        this.showAddContactForm = false;
        this.addContactLoading = false;
        this.openChatForContact({
          first_name: name,
          phone_number: phone
        });
      } catch (error) {
        this.addContactLoading = false;
        const response = error && error.response ? error.response.data : null;
        this.addContactError =
          (response && response.msg) ||
          (error && error.message) ||
          "Kontak gagal disimpan. Silakan coba lagi.";
      }
    },
    actShowHideUpdate(value) {
      this.showUpdate = value;
    },
    async filterContactListByName() {
      this.resetContactListArr();

      //   console.log("groupId", groupId);
      this.contactListParam.totalRecords = 0;
      this.contactListParam.rendered = 0;
      this.contactListParam.page = 0;
      this.contactListParam.perPage = 10;
      this.contactListParam.group_id = [];
      // Perubahan identifier memicu vue-infinite-loading mengambil halaman
      // pertama lagi. Jangan panggil handler kedua kali agar hasil tidak
      // di-reset oleh request yang berjalan bersamaan.
      this.infiniteId += 1;
    },
    async filterContactListGroup(groupId) {
      this.currentGroupId = groupId;
      this.resetContactListArr();

      //   console.log("groupId", groupId);
      this.contactListParam.totalRecords = 0;
      this.contactListParam.rendered = 0;
      this.contactListParam.page = 0;
      this.contactListParam.perPage = 10;
      this.contactListParam.group_id = [];
      if (groupId !== "") {
        this.contactListParam.group_id.push(groupId);
      }
      this.infiniteId += 1;

      //   this.infiniteHandlerContact();
    },
    async getGroupList() {
      this.loadingGroup = await false;
      await this.$store
        .dispatch("contact/getGroupList", this.contactListParam) // sesuai kan dengan method di API
        .catch(error => {
          //   this.loading = false;
          this.loadingGroup = false;

          console.log("error", error);
        });
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    resetContactListArr() {
      // Mutation Vuex berjalan sinkron agar reset tidak menimpa hasil fetch
      // yang datang setelahnya.
      this.$store.dispatch("contact/setContactListArr", []);
    },
    async changeContactListArr(data) {
      var newArr = await this.getUniqueListBy(data, "id");
      await this.$store.dispatch("contact/setContactListArr", newArr);
    },
    async infiniteHandlerContact($state) {
      this.loadingMessage = await true;

      await this.$store
        .dispatch("contact/getContactList", this.contactListParam) // sesuai kan dengan method di API
        .then(response => {
          console.log("response", response);
          console.log("response.data.length", response.data.length);
          const { data } = response;
          // Cegah baris ganda saat request awal dan reset infinite-loading
          // selesai hampir bersamaan.
          this.newData = data.filter(row => {
            return !this.contactListArr.some(item => item.id === row.id);
          });
          if (this.newData.length > 0) {
            this.contactListArr.push(...this.newData);
            this.changeContactListArr(this.contactListArr);
            this.contactListParam.rendered =
              this.contactListParam.page + response.recordsFiltered;
            this.contactListParam.page += response.recordsFiltered;
            if (response.totalRecords > 0) {
              this.contactListParam.totalRecords = response.totalRecords;
            }

            this.loadingMessage = false;
            // this.infiniteHandler(this.currentState, 0, 0);
            // $state.loaded();
          } else {
            this.loadingMessage = false;
            // $state.completed();
          }
          console.log("statttt", $state);
        })
        .catch(error => {
          this.loadingMessage = false;

          console.log("error", error);
        });
      this.currentState = await $state;
    }
  },
  async created() {
    this.$root.$on("openDirectChat", this.openDirectModal);
    this.$root.$on("openAddContact", this.openAddContactForm);
  },
  beforeDestroy() {
    this.$root.$off("openDirectChat", this.openDirectModal);
    this.$root.$off("openAddContact", this.openAddContactForm);
    const listElmDc = document.querySelector(".chat-user-list");
    if (listElmDc && this._directScrollHandler) {
      listElmDc.removeEventListener("scroll", this._directScrollHandler);
    }
  },
  mounted() {
    var listElmDc = document.querySelector(".chat-user-list");
    if (!listElmDc) {
      return;
    }
    this._directScrollHandler = e => {
      var currentScroll = listElmDc.scrollHeight - listElmDc.scrollTop;
      //   console.log("listElm.scrollTop::", listElm.scrollTop);
      //   console.log("listElm.clientHeight::", listElm.clientHeight);
      //   console.log("listElm.scrollHeight::", listElm.scrollHeight);

      console.log(
        "this.contactListParam.totalRecords",
        this.contactListParam.totalRecords
      );
      console.log("rendered", this.contactListParam.rendered);
      if (currentScroll == listElmDc.clientHeight) {
        console.log("this.contactListParam: ", this.contactListParam);
        console.log("end scroll");
        if (
          this.contactListParam.totalRecords > 0 &&
          this.contactListParam.rendered < this.contactListParam.totalRecords
        ) {
          this.infiniteHandlerContact();
          listElmDc.scrollTop = listElmDc.scrollTop - 10;
        }
      }

      // if (
      //   listElm.scrollHeight - listElm.scrollTop <=
      //   listElm.clientHeight + 50
      // ) {
      //   this.getUsers();
      // }

      //   console.log("calc", listElm.scrollHeight - listElm.scrollTop);
      //   console.log("calc2", listElm.clientHeight + 50);

      //   if (listElm.scrollTop === 0) {
      //     // if (listElm.scrollTop <= listElm.clientHeight) {
      //     // if (listElm.scrollTop + listElm.clientHeight === listElm.scrollHeight) {
      //     // console.log("dipucuk");
      //     this.infiniteHandlerContact(this.currentState);
      //     // console.log("this.hotChatParam.rendered", this.hotChatParam.totalData);
      //     // listElm.scrollTop = listElm.clientHeight;
      //     // listElm.scrollTop = 4679;
      //     listElm.scrollTop = 4500;
      //     // console.log("listElm.scrollTop::this.initScrollTop", listElm.scrollTop);

      //     // this.initScrollTop = listElm.scrollHeight;
      //     // console.log(
      //     //   "listElm.scrollTop::this.initScrollTop",
      //     //   this.initScrollTop
      //     // );

      //     // return;
      //     // this.scrollToBottom(true);
      //   } else {
      //     //stop loadmore
      //     this.infiniteHandlerContact(this.currentState);
      //   }
    };
    listElmDc.addEventListener("scroll", this._directScrollHandler);
  },
  name: "directChat"
};
</script>
<style scoped>
.waajo-direct-add-toggle {
  margin-left: auto;
  margin-right: 10px;
  padding: 6px 10px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.waajo-direct-add-toggle:hover {
  background: #ffefd4;
}

.waajo-direct-add-panel {
  padding: 12px;
  margin-bottom: 14px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 12px;
}

.waajo-direct-add-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.waajo-direct-add-head strong {
  display: block;
  color: #101828;
  font-size: 13px;
}

.waajo-direct-add-head small {
  display: block;
  margin-top: 2px;
  color: #667085;
  font-size: 10px;
}

.waajo-direct-add-panel .form-group {
  margin-bottom: 9px;
}

.waajo-direct-add-panel label {
  display: block;
  margin-bottom: 4px;
  color: #344054;
  font-size: 10px;
  font-weight: 600;
}

.waajo-direct-add-panel .form-control {
  height: 38px;
  border-color: #e2e8f2;
  border-radius: 8px;
  font-family: inherit;
  font-size: 11px;
}

.waajo-direct-add-error {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  margin: 8px 0;
  color: #b42318;
  font-size: 10px;
}

.waajo-direct-add-actions {
  display: flex;
  justify-content: flex-end;
  gap: 7px;
  margin-top: 10px;
}

.waajo-direct-add-actions .btn {
  min-height: 34px;
  padding: 7px 11px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 700;
}

.waajo-direct-add-actions .btn-primary {
  border-color: #f39c12;
  background: #f39c12;
}

@media (max-width: 575.98px) {
  .waajo-direct-add-toggle {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .waajo-direct-add-actions .btn {
    flex: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/omni/direct.vue